import { HudCard } from "./HudCard";
import { Brain, X } from "lucide-react";

function timeAgo(iso) {
  const then = new Date(iso).getTime();
  const secs = Math.floor((Date.now() - then) / 1000);
  if (secs < 60) return "à l'instant";
  const mins = Math.floor(secs / 60);
  if (mins < 60) return `il y a ${mins} min`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `il y a ${hrs} h`;
  const days = Math.floor(hrs / 24);
  return `il y a ${days} j`;
}

export function MemoryPanel({ memories, onDelete }) {
  return (
    <HudCard label={`BANQUE MÉMOIRE // ${memories.length} ENREGISTRÉES`} className="flex flex-col h-full">
      <div data-testid="memory-panel" className="flex-1 overflow-y-auto px-4 py-3 space-y-2 min-h-0">
        {memories.length === 0 && (
          <div className="text-center py-6">
            <Brain className="h-6 w-6 mx-auto mb-2 text-[#334]" />
            <p className="font-mono-hud text-[11px] text-[#556] tracking-wide leading-relaxed">
              » Rien en mémoire pour l'instant.
              <br />
              Confiez un fait vous concernant à Sara Connor et il sera enregistré ici.
            </p>
          </div>
        )}
        {memories.map((m) => (
          <div
            key={m.id}
            data-testid="memory-item"
            className="group flex items-start gap-2 px-3 py-2.5 bg-[rgba(255,255,255,0.03)] border border-[var(--border-hud)] clip-corner animate-rise"
          >
            <span className="mt-1 h-1.5 w-1.5 rounded-full bg-[var(--accent)] shrink-0 accent-glow" />
            <div className="flex-1 min-w-0">
              <p className="text-[13px] leading-snug text-[#dbe7f3]">{m.fact}</p>
              <span className="font-mono-hud text-[9px] tracking-wider text-[#556]">{timeAgo(m.created_at)}</span>
            </div>
            <button
              data-testid="memory-delete-button"
              onClick={() => onDelete(m.id)}
              aria-label="Forget"
              className="opacity-0 group-hover:opacity-100 transition-opacity h-6 w-6 flex items-center justify-center text-[#ff6b6b] hover:bg-[rgba(255,107,107,0.12)] rounded"
            >
              <X className="h-3.5 w-3.5" />
            </button>
          </div>
        ))}
      </div>
    </HudCard>
  );
}
